import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" Are you sure you want to remove ")
const _hoisted_2 = ["title"]
const _hoisted_3 = /*#__PURE__*/_createTextVNode()
const _hoisted_4 = ["title"]
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" from set ")
const _hoisted_6 = ["title"]
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" in dataset ")
const _hoisted_8 = ["title"]
const _hoisted_9 = /*#__PURE__*/_createTextVNode("? ")
const _hoisted_10 = ["onClick"]
const _hoisted_11 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Modal = _resolveComponent("Modal")!

  return (_openBlock(), _createBlock(_component_Modal, {
    "model-value": _ctx.modelValue,
    title: 'Remove ' + _ctx.truncateShort(_ctx.typeName(_ctx.element.type)) + ' ' + _ctx.truncateShort(_ctx.element.name),
    "onUpdate:modelValue": _ctx.updateModelValue
  }, {
    footer: _withCtx(({ close }) => [
      _createElementVNode("button", {
        class: "button",
        onClick: _withModifiers(close, ["prevent"])
      }, "Cancel", 8, _hoisted_10),
      _createElementVNode("button", {
        class: _normalizeClass(["button is-danger", { 'is-loading': _ctx.loading }]),
        disabled: !_ctx.canRemove || undefined,
        onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.performRemove && _ctx.performRemove(...args)), ["prevent"]))
      }, " Remove ", 10, _hoisted_11)
    ]),
    default: _withCtx(() => [
      _createElementVNode("p", null, [
        _hoisted_1,
        _createElementVNode("span", {
          title: _ctx.typeName(_ctx.element.type)
        }, _toDisplayString(_ctx.truncateShort(_ctx.typeName(_ctx.element.type))), 9, _hoisted_2),
        _hoisted_3,
        _createElementVNode("span", {
          title: _ctx.element.name
        }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.truncateShort(_ctx.element.name)), 1)
        ], 8, _hoisted_4),
        _hoisted_5,
        _createElementVNode("span", { title: _ctx.set }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.truncateShort(_ctx.set)), 1)
        ], 8, _hoisted_6),
        _hoisted_7,
        _createElementVNode("span", {
          title: _ctx.dataset.name
        }, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.truncateShort(_ctx.dataset.name)), 1)
        ], 8, _hoisted_8),
        _hoisted_9
      ])
    ]),
    _: 1
  }, 8, ["model-value", "title", "onUpdate:modelValue"]))
}